﻿import AttachmentType from "../enums/AttachmentType";
import PaymentMethod from "../enums/PaymentMethod";
import {AvailablePaymentMethods} from "../types/AvailablePaymentMethods";
import {FormAttachmentData} from "../types/FormAttachmentData";

export function updatePaymentMethod(paymentMethod: AvailablePaymentMethods, permitAttachments: FormAttachmentData[]): AvailablePaymentMethods {
	if (paymentMethod.method === PaymentMethod.BankTransfer) {
		paymentMethod.bankTransferId = permitAttachments.find(x => x.type === AttachmentType.BankTransferId)?.blobId ?? "";
	}

	return paymentMethod;
}
